import {Pill} from '@hm/fundamental'

import {statusColor} from '../../helpers'
import {useRiskSurveyTranslation} from '../../hooks'
import type {RiaStatus} from '../../types'

type RiaStatusPillProps = {
  status: RiaStatus
}

export const RiaStatusPill = ({status}: RiaStatusPillProps) => {
  const {t} = useRiskSurveyTranslation()

  return (
    <Pill
      type={statusColor[status]}
      text={t(`status.${status}`)}
      aria-label={`${t('detail.status')}: ${t(`status.${status}`)}`}
      variant="shade"
      size="regular"
      data-cy={`ria-status-pill-${status}`}
    />
  )
}
